import { render, staticRenderFns } from "./AssignDeviceHistory.vue?vue&type=template&id=f1070da2&scoped=true"
import script from "./AssignDeviceHistory.vue?vue&type=script&lang=js"
export * from "./AssignDeviceHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1070da2",
  null
  
)

export default component.exports